var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelDisplayAdFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.926 4C18.624 4 20 7.576 20 11.987s-1.376 7.986-3.074 7.986c-.707 0-1.358-.62-1.877-1.663l-.004.003c-1.654-2.16-4.36-3.038-6.55-3.387l.98 3.652a1 1 0 0 1-.699 1.226l-.507.136a.994.994 0 0 1-1.217-.712l-1.212-4.52c-.534-.003-.854.02-.854.02A.96.96 0 0 1 4 13.754v-3.379c0-.551.446-.988.995-.991 0 0 7.137.421 10.182-3.982C15.68 4.52 16.28 4 16.927 4M16.2 7.225c-.829 0-1.5 2.166-1.5 4.838s.671 4.838 1.5 4.838c.828 0 1.5-2.166 1.5-4.838s-.672-4.838-1.5-4.838"
})));
export default SvgGemChannelDisplayAdFilled;